// src/pages/restaurant/AddMenu.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import api from "../../utils/api";
import AdvancedMenuForm from "../../components/restaurant/menu/AdvancedMenuForm";
import SimpleMenuForm from "../../components/restaurant/menu/SimpleMenuForm";
import AdvancedMenuFormEdit from "../../components/restaurant/menu/AdvancedMenuEditForm";
 

const AddMenu = () => { 
  const navigate = useNavigate();
  const [inventory, setInventory] = useState([]);
  const [selectedTab, setSelectedTab] = useState("simple"); // "simple" or "advanced"

  useEffect(() => { 

    api
      .get("restaurant/inventory/get")
      .then((res) => {
        console.log('in',res.data?.items || [])
        setInventory(res.data?.inventory || []);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="flex items-center gap-4 mb-6">
        <button onClick={() => navigate(-1)} className="p-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors" title="Back to Menus">
          <FaArrowLeft />
        </button>
        <h2 className="text-3xl font-bold">Add Menu</h2>
      </div>

      {/* Tabs */}
      <div className="flex space-x-4 mb-6 border-b">
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "simple"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("simple")}
        >
          Simple
        </button>
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "advanced"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("advanced")}
        >
          Advanced
        </button>
      </div>

      {/* Content */}
      {selectedTab === "simple" ? (
        <SimpleMenuForm inventory={inventory} />
      ) : (
        <AdvancedMenuForm   inventory={inventory} />
        //  <AdvancedMenuFormEdit inventory={inventory}  />
      )}
    </div>
  );
};

export default AddMenu;
